export const DISPLAY_NAME_CHANGE = 'DISPLAY_NAME_CHANGE';
export const UPDATE_DISPLAY_NAME = 'UPDATE_DISPLAY_NAME';

export const setDisplayName = displayName => ({
  type: UPDATE_DISPLAY_NAME,
  displayName,
});

export const displayNameChange = displayName => ({
  ...displayName,
  editing: 'displayName',
  type: DISPLAY_NAME_CHANGE,
  saving: true,
});

export default {
  displayNameChange,
};
